import React from 'react'
import {connect} from 'react-redux'
import Route from '../router/Route'
import WorkThumb from './WorkThumb'
import WorkItem from './WorkItem'
import WorkRoutes from './WorkRoutes'

import WholePxFixer from '../misc/WholePxFixer'

import MetaTags from 'react-meta-tags'


class WorkPage extends React.Component {

  constructor(){
    super();

    this.state = {
        rows:[]
    }

    this.thumbnailOnClickPosition = this.thumbnailOnClickPosition.bind(this)
    this.splitIntoGrid = this.splitIntoGrid.bind(this)
  }

  getWorkItem(){
    // check for the workitem on load
    if(window.location.pathname.split.length>1){
      let workPice = window.location.pathname.split('/work/')[1];
      //console.log('workPiece', workPice);
    }



  }

  shouldComponentUpdate(){

    //console.log("Update Workpage",this.props);

    return true;
  }

  componentDidMount(){
    this.getWorkItem()
    this.splitIntoGrid();
    window.addEventListener('resize', this.splitIntoGrid)
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.splitIntoGrid)
  }

  openPiece(){

  }

  thumbnailOnClickPosition(ref){
      //console.log("Thumb Clicked",ref);
      window.clickedThumb = ref

      // apply an open class to the thumbnail

      let thumbs = document.querySelectorAll('.link-thumb');

        for(let i = 0; i < thumbs.length; i++){
          thumbs[i].classList.remove('open')
        }

        ref.classList.add('open')

  }

  splitIntoGrid(){
    let workPices = this.props.workData.data.slice()



    // 19 dublicates of the first pice
    /*
    for(let i=0;i < 19 ; i++){
      workPices.push(workPices[0])
    }*/


    // split the work into rows
    //let rows = []

    let coloumns = 4

    let i,j,chunk = coloumns;

    if(window.innerWidth < 769){
      chunk = 2;
      coloumns = 2
    }


    //  if(item.acf.show_on_work_page !== false){

  //    for (i=0,j=workPices.length; i < j; i+=chunk) {
  //        rows.push(workPices.slice(i,i+chunk));
  //    }


        let rows = [[]]
      let workCounter = -1;
      let currentRow = 0;
      workPices.map((item,i)=>{


          if(item.acf.show_on_work_page !== false){
            rows[currentRow].push(item)
            workCounter++
          }

          if(workCounter % coloumns === coloumns-1){
            rows.push([])
            currentRow++
          }



      })

      if(rows.length!==this.state.rows.length){
        this.setState({rows})
      }
  }


  render () {

        //console.log('WorkPage',this);



        //console.log('rows',rows);

        //console.log('workpage',this.props);

        let rows = this.state.rows


        return (<div className="work-page scroll-anchor" >

                <div className="work-item-container">
                  {
                      <WorkRoutes workData={this.props.workData} />
                  }
                </div>

                <div className="work-items">

                    {
                      rows.map((row,row_num)=>{

                          return (
                              <div className="row" key={"row"+row_num} >
                                {
                                  row.map((item,index)=>{


                                        return (
                                            <WorkThumb  key={'wp'+index} {...item} thumbnailOnClickPosition={this.thumbnailOnClickPosition} ></WorkThumb>
                                          )

                                    })

                                }
                                </div>
                              )

                              })

                    }

                </div>

                <WholePxFixer watchList=".link-thumb" />


          </div>)
  }
}

const mapStateToProps = (state)=>{
    const workData = state.KastnerStore.workData

    return {
      workData
    }
}

export default connect(mapStateToProps)(WorkPage)



// WEBPACK FOOTER //
// ./src/modules/work/WorkPage.js